import type { AddressProviderData, AddressProviderUpdateData, ApiRequestFn } from "../../types/api";
import type { Address, AddressProvider, AddressWithProviders } from "../../types/models";

const createAddressesApi = (request: ApiRequestFn) => ({
  list: () => request<AddressWithProviders[]>("/me/addresses"),
  get: (id: number) => request<AddressWithProviders>(`/me/addresses/${id}`),
  create: (name: string) => request<Address>("/me/addresses", { method: "POST", body: JSON.stringify({ name }) }),
  update: (id: number, name: string) => request<Address>(`/me/addresses/${id}`, { method: "PATCH", body: JSON.stringify({ name }) }),
  remove: (id: number) => request<void>(`/me/addresses/${id}`, { method: "DELETE" }),

  assignProvider: (addressId: number, data: AddressProviderData) =>
    request<AddressProvider>(`/me/addresses/${addressId}/providers`, {
      method: "POST",
      body: JSON.stringify(data),
    }),

  removeProvider: (addressId: number, providerId: number) =>
    request<void>(`/me/addresses/${addressId}/providers/${providerId}`, { method: "DELETE" }),

  updateProvider: (addressId: number, providerId: number, data: AddressProviderUpdateData) =>
    request<AddressProvider>(`/me/addresses/${addressId}/providers/${providerId}`, {
      method: "PATCH",
      body: JSON.stringify(data),
    }),
});

export { createAddressesApi };
